import React from "react";

type Props = {
  width: number;
  height: number;
};
export const ProjectSVG: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 34 34`}
    >
      <g transform="translate(4.421 6.051)">
        <rect
          id="Frame"
          width="34"
          height="34"
          rx="1"
          transform="translate(-4.421 -6.051)"
          fill="rgba(0,0,0,0)"
          opacity="0"
        />
        <g transform="translate(0.579 -0.301)" clipPath="url(#clip-path)">
          <path
            d="M51.047,0a2.812,2.812,0,1,1-2.813,2.813A2.813,2.813,0,0,1,51.047,0"
            transform="translate(-39.047)"
          />
          <path
            d="M10.441,0A2.812,2.812,0,1,1,7.629,2.813,2.813,2.813,0,0,1,10.441,0"
            transform="translate(-6.176)"
          />
          <path
            d="M91.653,0A2.812,2.812,0,1,1,88.84,2.813,2.812,2.812,0,0,1,91.653,0"
            transform="translate(-71.918)"
          />
          <path
            d="M74.778,84.9a.7.7,0,1,1-.7.7.7.7,0,0,1,.7-.7"
            transform="translate(-59.965 -68.73)"
          />
          <path
            d="M45.246,84.9a.7.7,0,1,1-.7.7.7.7,0,0,1,.7-.7"
            transform="translate(-36.059 -68.73)"
          />
          <path
            d="M35.93,66.445H30.3a4.223,4.223,0,0,0-4.219,4.219V74.3a1.989,1.989,0,0,0,3.395,1.406l.824-.824H35.93l.824.824A1.989,1.989,0,0,0,40.148,74.3V70.664a4.223,4.223,0,0,0-4.219-4.219M30.3,72.773a2.109,2.109,0,1,1,2.109-2.109A2.112,2.112,0,0,1,30.3,72.773m5.625,0a2.109,2.109,0,1,1,2.109-2.109,2.112,2.112,0,0,1-2.109,2.109"
            transform="translate(-21.117 -53.789)"
          />
          <path
            d="M.7,36.562h4.8a5.643,5.643,0,0,1,.868-.624V33.75a5.577,5.577,0,0,1,.875-2.982,4.2,4.2,0,0,0-2.984-1.237A4.259,4.259,0,0,0,0,33.75v2.109a.7.7,0,0,0,.7.7"
            transform="translate(0 -23.906)"
          />
          <path
            d="M47.883,35.157a5.56,5.56,0,0,1,1.406.2V33.751a4.219,4.219,0,0,0-8.438,0v1.606a5.56,5.56,0,0,1,1.406-.2Z"
            transform="translate(-33.071 -23.907)"
          />
          <path
            d="M90.924,29.531a4.205,4.205,0,0,0-2.984,1.237,5.574,5.574,0,0,1,.875,2.982v2.189a5.627,5.627,0,0,1,.868.624h4.8a.7.7,0,0,0,.7-.7V33.75a4.259,4.259,0,0,0-4.266-4.219"
            transform="translate(-71.19 -23.906)"
          />
        </g>
      </g>
    </svg>
  );
};
